import { ErrorService } from '@agilox/common';
import { ErrorPageComponent } from '@agilox/components';
import { Component, computed, inject } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { AuthService } from '@auth';

@Component({
	imports: [ErrorPageComponent, RouterOutlet],
	selector: 'my-root',
	templateUrl: './app.component.html',
})
export class AppComponent {
	private authService = inject(AuthService);
	private errorService = inject(ErrorService);

	serverError = computed(() => this.errorService.serverError());

	logout(): void {
		this.authService.logout();
	}
}
